// @flow
import * as React from 'react';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import style from './style';
import type { Props } from './props';

// eslint-disable-next-line no-unused-vars
const Options = ({ title = '', onClick = (e: string) => {} }: Props): React.Element<any> => (
  <Button
    onClick={onClick}
    style={style.removeFeed}
    title={title}
  >
    <FontAwesome name="trash" />
  </Button>
);

export default Options;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/components/Options/Options.js